import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=a6b3210c&scoped=true&"
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"
import style0 from "./carousel.vue?vue&type=style&index=0&id=a6b3210c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b3210c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeEvent: require('/var/web/bet777.es/components/home/event.vue').default,HomePromotion: require('/var/web/bet777.es/components/home/promotion.vue').default})
